import Bragina from "pages/event/assets/Bragina.png";

export const schedule = [
  {
    id: 1,
    startTime: "09:30",
    endTime: "10:00",
    title: "Регистрация участников",
  },
  {
    id: 2,
    startTime: "10:00",
    endTime: "10:10",
    title: "Открытие конгресса",
  },
  {
    id: 3,
    startTime: "10:10",
    endTime: "11:00",
    title: "Рубцы! Что нового и интересного?",
    image: Bragina,
    experts: ["Брагина Ирина Юрьевна"],
  },
];
